export const generateToken = () => {
  return JSON.parse(localStorage.getItem("authTokens")).data.accessToken;
}